module.exports = __webpack_public_path__ + "img/passo3.9fc57c44.gif";